import MediaKpiModule from '@/models/MediaKpiModule'
import SystemDashboard from '@/models/SystemDashboard'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'

import RowWidget from '@/pages/ManagementDashboardV2/settings/widgets/RowWidget'
import SelectOption from '@/models/interface/SelectOption'
import ProfitInventoryMG from '../widgets/finance/ProfitInventoryMG'
import ProfitOverviewCards from '../widgets/finance/ProfitOverviewCards'
import SaleProfitTableWidget from '../widgets/finance/SalesChannelProfitWidget'
import RegionProductFilterWidget from '../widgets/others/RegionProductFilterWidget'
import DateRangeFilter from '../filters/DateRangeFilter'
import { FILTERS } from '../helpers'

import ColumnSelector from '../filters/ColumnSelector'
import YearMonthQuarterColumnToggle from '../filters/YearMonthQuarterColumnToggle'
import RegionDashboardFilter from '../filters/RegionDashboardFilter'
import ProductDashboardFilter from '../filters/ProductDashboardFilter'
import SpecialGroupFilter from '../filters/SpecialGroupFilter'

export default class MediaKPIModule extends SystemDashboard {
  public title = 'Media KPIs'

  public key: string = 'media_kpi'

  public querySettings = {
    company_fields: [
      {
        name: 'agency',
        key: 'agency',
        type: 'agency',
      },
      {
        name: 'advertiser',
        key: 'advertiser',
        type: 'advertiser',
      },
    ],
    custom_fields: [
      {
        name: 'deal_type:direct',
        value: 'deal_type:direct',
      },
      {
        name: 'deal_type:3rd Party',
        value: 'deal_type:3rd_party',
      },
      {
        name: 'deal_type:All',
        value: 'deal_type:all',
      },
    ],
    user_fields: [
      {
        name: 'sr',
        key: 'sales_rep_id',
      },
    ],
  }

  public refreshInternalTableFields: any = {
    fields: [
      {
        label: 'RPM',
        value: 'rpm',
        show: false,
      },
      {
        label: 'eRPM',
        value: 'erpm',
        show: false,
      },
      {
        label: 'CPM',
        value: 'cpm',
        show: false,
      },
    ],
  }

  public filters = {
    product: 'ssl',
    region: 'all',
    special_group: 'all',
    ...FILTERS.YEAR,
  }

  public internalProps: any = {
    columns: {
      show_rpms: true,
      show_cpm: true,
      show_quarters: true,
    },
  }

  public widgets: SystemDashboardWidget[] = [
    new RegionProductFilterWidget({
      leftCol: [
        new RegionDashboardFilter(),
        new ProductDashboardFilter(),
      ],
      rightCol: [
        new SpecialGroupFilter(),
      ],
    }),

    new ProfitOverviewCards(),

    new SaleProfitTableWidget({
      firstLabel: 'Sales Channel',
      internalQueryPush: 'select_by:sales_channel',
      conditionalFields: [],
    }),

    new SaleProfitTableWidget({
      title: 'Product',
      key: 'product-profit',
      firstLabel: 'Product',
      internalQueryPush: 'select_by:product',
      conditionalCellClass: (header: any) => {
        const label: string = header.label

        let _class = 'text-capitalize'

        if (label.toLocaleLowerCase() === 'product') {
          _class = 'text-uppercase'
        }

        return _class
      },
    }),

    new SaleProfitTableWidget({
      title: 'Source',
      key: 'source-profit',
      firstLabel: 'Source',
      internalQueryPush: 'select_by:source',
    }),

    new SaleProfitTableWidget({
      title: 'League',
      key: 'league-profit',
      firstLabel: 'league',
      internalQueryPush: 'select_by:league',
    }),

    new SaleProfitTableWidget({
      title: 'Agency',
      key: 'agency-profit',
      firstLabel: 'Agency',
      internalQueryPush: 'select_by:agency',
    }),

    new SaleProfitTableWidget({
      title: 'Advertiser',
      key: 'advertiser-profit',
      firstLabel: 'Advertiser',
      internalQueryPush: 'select_by:advertiser',
    }),

    new ProfitInventoryMG(),
  ]
}
